import LuxonUtils from '@date-io/luxon';
import { weekCalculationUtil } from '~/modules/common/dates/weekUtil';

/**
 * Overrides the Luxon utils to provide the monthly calendar according
 * to the specification of the locale.
 *
 * For example, in France, Australia, Canada, and USA the week starts on
 * Sunday. Other locales have the week start on Monday.
 */

const createCustomLuxonUtils = workWeekStartUri => {
  class CustomLuxonUtils extends LuxonUtils {
    getWeekdays() {
      return weekCalculationUtil.getWeekdays(workWeekStartUri);
    }

    getWeekArray(date) {
      return weekCalculationUtil.getWeekArray(date, workWeekStartUri);
    }
  }

  return CustomLuxonUtils;
};

export default createCustomLuxonUtils;
